/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import "assets/css/material-dashboard-react.css?v=1.8.0";
import { siteName } from "variables/config.json";
import logo from "assets/img/Logo.png";
import Notifier from "components/Snackbar/Notifier";
import Confirm from "components/Confirm";
import { createBrowserHistory } from "history";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";
import ReactDOM from "react-dom";
import Provider from "react-redux/es/components/Provider";
import { Router as DomRouter } from "react-router-dom";
import store from "./redux";
import Router from "./Router.js";
import {
  primaryColor,
  secondaryColor,
} from "assets/jss/material-dashboard-react.js";
import "assets/css/flex.css";

function noop() {}

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

const hist = createBrowserHistory();
const theme = createTheme({
  palette: {
    primary: {
      light: "#445a8c",
      main: "#445a8c",
      dark: primaryColor[3],
      contrastText: "#fff",
    },
    secondary: {
      light: "#445a8c",
      main: "#445a8c",
      dark: secondaryColor[3],
      contrastText: "#fff",
    },
  },
});

const setState = React.Component.prototype.setState;
React.Component.prototype.setState = function (newState, cb) {
  return new Promise((resolve) =>
    setState.call(this, newState, (_) => {
      if (cb) cb();
      resolve();
    })
  );
};
const resolveApiBaseUrl = () => {
  const runtimeBase =
    typeof window !== "undefined" && window.__ENV__
      ? window.__ENV__.REACT_APP_API_BASE_URL
      : undefined;
  return (
    runtimeBase ||
    process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === "development"
      ? "http://localhost:4000/api"
      : "/api")
  );
};

const normalizeAssetUrl = (value) => {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/")) return value;
  return `/${value.replace(/^\/+/, "")}`;
};

const setFavicon = (href) => {
  if (!href || typeof document === "undefined") return;
  let icon = document.querySelector("link[rel='shortcut icon']");
  if (!icon) {
    icon = document.querySelector("link[rel='icon']");
  }
  if (!icon) {
    icon = document.createElement("link");
    icon.rel = "icon";
    document.head.appendChild(icon);
  }
  icon.setAttribute("href", href);
};

const applyPublicBranding = async () => {
  try {
    const base = resolveApiBaseUrl().replace(/\/+$/, "");
    const response = await fetch(`${base}/design/public-branding`, {
      credentials: "same-origin",
    });
    if (!response.ok) return;
    const data = await response.json();
    if (data && data.homeLogoUrl) {
      window.siteLogo = normalizeAssetUrl(data.homeLogoUrl);
    }
    if (data && data.faviconUrl) {
      setFavicon(normalizeAssetUrl(data.faviconUrl));
    }
  } catch (_) {
    // keep bundled branding assets when design endpoint is unavailable
  }
};

const renderApp = () =>
  ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <Notifier />
        <Confirm />
        <DomRouter history={hist}>
          <Router />
        </DomRouter>
      </MuiThemeProvider>
    </Provider>,
    document.getElementById("root")
  );

window.siteLogo = logo;
window.document.title = siteName;
applyPublicBranding().finally(() => renderApp());

/**
 * si payé: envoyer fichier au locataire
 * si pas payé: setup toute les semaine une relance au locataire pendant 2 semaine
 * anglais tablea
 * couleur #445a8c
 */


